import RegionSwitch from '../../../components/region-switcher';

export default function initRegionSwitch() {
	const wrappers = document.querySelectorAll('.js-region-switcher__wrapper');
	[...wrappers].forEach((wrapper) => {
		// eslint-disable-next-line no-new
		new RegionSwitch(wrapper);
	});
}
